<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <!--page body contant -->
            <!--header-->
            <div class="row row-replace add-m-b">
                <div class="col-md-6 col-7 col-p h5"><i class="fa fa-bed"></i> Accommodation List </div>
                <div class="col-md-6 col-5 top-corner-items col-p">
                    <button class="btn btn-primary btn-sm"><i class="fa fa-cloud-download"></i> Download Policy</button>
                </div>
            </div>
            <!--end header-->

       <!-- Accommodation list table 1  -->
            <div class="row row-replace m-t-10">
               
                <div class="col-12 col-pn">
                   <div class="table-responsive">
                      <table class="table default-table">
                         <thead>
                             <tr class="bg-primary text-white">
                                 <th></th>
                                 <th colspan="4">Total Agreements Renewal</th>
                                 <th colspan="4">Total Agreements Expire</th>
                                 <th></th>
                             </tr>
                            <tr class="bg-primary text-white">
                            <th>Total Accommodations</th>
                            <th>Total Renewal</th>
                            <th> < 30 days </th>
                            <th> < 20 days</th>
                            <th> < 10 days</th>
                            <th>Total Expire</th>
                            <th> > 10 days</th>
                            <th> > 20 days</th>
                            <th> > 30 days</th>
                            <th>Pending Audits</th>
                            </tr>
                         </thead>
                         <tbody>
                            <tr>
                               <td>col 1</td>
                               <td>col 2</td>
                               <td>col 3</td>
                               <td>col 4</td>
                               <td>col 5</td>
                               <td>col 6</td>
                               <td>col 7</td>
                               <td>col 8</td>
                               <td>col 9</td>
                               <td>col 10</td>
                            </tr>
                         </tbody>
                         
                      </table>
                   </div>
                </div>
             </div>

             <div class="row row-replace m-t-10">
                <div class="col-md-8">
                    <div class="row">
                    <div class="col-md-4 col-p form-group"><input type="text" class="form-control" placeholder="Select Site Name"></div>
                    <div class="col-md-4 col-p form-group"><input type="text" class="form-control" placeholder="Select Segment"></div>
                    <div class="col-md-4 col-p form-group"><input type="text" class="form-control" placeholder="Select Action"></div>
                  </div>
                </div>
                <div class="col-md-4">
                    <div class="row row-replace">
                        <div class="col-3 col-p"><button class="btn btn-primary btn-sm"> <i class="fa fa-search"></i> Search</button></div>
                        <div class="col-3 col-p"><button class="btn btn-danger btn-sm"> <i class="fa fa-refresh"></i> Reset</button></div>
                        <div class="col-3 col-p"><button class="btn btn-warning btn-sm"> <i class="fa fa-file"></i> Report</button></div>
                        <div class="col-3 col-p"><button class="btn btn-success btn-sm" (click)="upload_Accommodation_doc()"> <i class="fa fa-upload"></i> Upload</button></div>
                    </div>
                </div>
            </div>

             <!-- Accommodation list table 2  -->

             <div class="row row-replace m-t-10">
                <div class="col-12 col-pn">
                    <button class="btn btn-success btn-sm m-b-10"><i class="fa fa-check-square-o"></i> Bulk Approve</button>
                   <div class="table-responsive">
                      <table class="table default-table">
                         <thead>
                            
                            <tr class="bg-primary text-white">
                            <th>All <input type="checkbox"></th>
                            <th>Sr no.</th>
                            <th>Agreement Id</th>
                            <th> Accommodation Address</th>
                            <th>Pincode</th>
                            <th> Warden Name</th>
                            <th>Site Manager Name</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Final Remarks</th>
                            <th>Utility Status</th>
                            <th>Action</th>
                            </tr>
                         </thead>
                         <tbody>
                            <tr>
                               <td>col 1</td>
                               <td>col 2</td>
                               <td>col 3</td>
                               <td>col 4</td>
                               <td>col 5</td>
                               <td>col 6</td>
                               <td>col 7</td>
                               <td>col 8</td>
                               <td>col 9</td>
                               <td>col 10</td>
                               <td>col 11</td>
                               <td>
                                <div class="btn-group btn-group-sm">
                                    <button class="btn-danger"><i class="fa fa-pencil-square-o"></i></button>
                                    <button class="btn-success"><i class="fa fa-history"></i></button>
                                    <button class="btn-primary"><i class="fa fa-eye"></i></button>
                                </div>


                               </td>
                            </tr>
                         </tbody>
                         
                      </table>
                   </div>
                </div>
             </div>

      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->           





<!-- Accommodation modal -->
<div id="Accommodation_doc" class="modal custom-modal fade" role="dialog" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md">
       <div class="modal-content">
          <div class="modal-header">
             <h5 class="modal-title">Upload Accommodations</h5>
             <button type="button" class="close" data-dismiss="modal" aria-label="Close">
             <span aria-hidden="true">×</span>
             </button>
          </div>
          <div class="modal-body">
             <div class="row">
               <div class="col-12">
                <hr>
                <button class="btn btn-primary btn-sm"><i class="fa fa-cloud-download"></i> Download CSV</button>
                <div class="border m-t-20 p-20">
                    <table class="default-table">
                        <tr>
                            <td>Select File</td>
                            <td><input type="file" class="form-control border-white"></td>
                        </tr>
                        <tr>
                            <td>Import data</td>
                            <td><button class="btn btn-primary btn-sm"><i class="fa fa-arrow-right"></i> Import</button></td>
                        </tr>
                    </table>
                </div>
             </div>
             </div>
          </div>
       </div>
    </div>
 </div>
 <!--end third model-->


